import FuturesEvidencePanel from './FuturesEvidencePanel'

export default function FuturesAllocationListView() {
  return (
    <FuturesEvidencePanel
      title="Allocation"
      accessLabel="Allocation"
      accessTarget="frmFuturesMainSubFormAllocation -> frmFuturesQryAllocation"
      description="Futures allocation workflow for assigning futures lots to purchase or sales contracts, including the Access Check - No Alc helper."
      actions={['New', 'Edit', 'Delete', 'Check - No Alc']}
      evidence={[
        'form_frmFuturesMainSubFormAllocation.txt',
        'form_frmFuturesQryAllocation.txt',
        'form_frmFuturesQryAllocation_noalc.txt',
        'form_frmFuturesQryAllocationAdd.txt',
        'form_frmFuturesQryAllocationAdd_noalc.txt',
        'query_FuturesQryAllocation.txt',
        'query_FuturesQryAllocation_noalc.txt',
      ]}
      notes={[
        'Edit disables date, contract_p, contract_s, and futures_id, then prefills balance and not-allocated lots from lookup tables.',
        'Delete soft-deletes public_futures_allocation by date, contract_id, futures_id, and is_status=0.',
        'Check - No Alc opens frmFuturesQryAllocationAdd_noalc.',
      ]}
    />
  )
}
